<template>
  <BaseModal
    :value="true"
    :modal-title="$t('utils.edit_collaborator_function')"
    @close="close"
  >
    <template #modal>
      <form class="modal_content" @submit="submit()">
        <BaseTextField
          v-model="form.email"
          disabled
          :label="`${$tc('utils.email', 1)} *`"
        />
        <BaseAutocomplete
          v-model="form.role"
          :label="`${$t('utils.function')} *`"
          solo
          outlined
          :items="COLLABORATOR_ROLE"
          item-text="name"
          item-value="id"
          :error-messages="roleErrors"
          :has-error="!!roleErrors"
        />
      </form>
    </template>

    <template #actions>
      <BaseButton
        class="mx-2 ml-auto"
        color="primary"
        type="primary"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton
        type="secondary"
        text
        color="#707080"
        :loading="isSubmiting"
        @click="submit"
      >
        {{ $t("utils.save") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import OrganizationAPI from "@/core/Services/organization.api";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "EditCollaboratorFunction",
  mixins: [validationMixin],
  props: {
    collaborator: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubmiting: false,
      form: {
        email: null,
        role: null,
      },
      COLLABORATOR_ROLE: [
        {
          name: this.$t("utils.administrator"),
          id: "ADMINISTRATOR",
        },
        {
          name: this.$t("organization.member"),
          id: "MEMBER",
        },
      ],
    };
  },
  validations: {
    form: {
      role: {
        required,
      },
    },
  },
  computed: {
    roleErrors() {
      if (!this.$v.form.role.$dirty) {
        return "";
      }
      if (!this.$v.form.role.required) {
        return this.$t("utils.fieldIsRequired");
      }
      return "";
    },
  },
  created() {
    this.initForm();
  },
  methods: {
    initForm() {
      this.form.email = this.collaborator.user.email;
      this.form.role = this.collaborator.status;
    },
    close() {
      this.form.email = null;
      this.form.role = null;
      this.$emit("close");
    },
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.isSubmiting = true;
      try {
        const res = await OrganizationAPI.patchCollaboratorFunction({
          organizationId: this.$route.params.organizationId,
          collaboratorId: this.collaborator.id,
          role: this.form.role,
        });
        this.$emit("collaboratorUpdated", res.data);
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.snackbar.editSuccess"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.close();
    },
  },
};
</script>
